<template>
    <div>
        <pagamento-associar-consultorias
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
        ></pagamento-associar-consultorias>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import PagamentoAssociarConsultorias from '@/app/appsebrae/consultorias/componentes/pagamentos/PagamentoAssociarConsultorias'

export default {
    props: {
        pagamento: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        }
    },

    components: {
        PagamentoAssociarConsultorias
    }
}
</script>
